module.exports = __webpack_public_path__ + "frontend/images/favicons/mstile-310x150.png?f755a26f2655721dcc282e5d8e1453da";